<template>
    <label class="input">
      <!-- <span class="input__label" v-if="label">{{ label }}</span> -->
      <input
        class="input__field"
        :type="type"
        :value="modelValue"
        :placeholder="label"
        :required="required"
        @input="updateValue"
      >
    </label>
  </template>
  
  <script setup>
  import { defineProps, defineEmits } from 'vue'
  
  const props = defineProps({
    modelValue: {
      type: String,
      default: ''
    },
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    }
  })
  const emit = defineEmits(['update:modelValue'])
  
  const updateValue = (event) => {
    emit('update:modelValue', event.target.value)
  }
  </script>
  
  <style lang="scss">
  .input {
    display: flex;
    height: 48px;
    padding: 0 14px;
    border: 1px solid var(--border);
    border-radius: var(--border-radius);
    position: relative;
    background: #fff;
  
    input {
      height: 100%;
      width: 100%;
      background: #fff;
    }
  
    &__label {
      position: absolute;
      top: -25%;
      left: 10px;
      font-size: 14px;
      color: var(--color-soft);
      background: var(--background-box);
      padding: 0 5px;
  
      &::first-letter {
        text-transform: uppercase;
      }
    }
  }
  //INPUT[type="text"], 
  INPUT[type="email"], INPUT[type="password"] {
    &:not([class]) {
      height: 48px;
      padding: 0 14px;
      border: 1px solid var(--border);
      border-radius: var(--border-radius);
      &::placeholder {
        color: #8a96a3;
      }
    }
  }
  </style>
  